import { Checkbox, TextBase } from '@carboncopyco/ui';
import { Field, type FieldProps, useFormikContext } from 'formik';

import type { ShareDemoModalState } from './ShareDemoModal';
import { useGuidedSandboxModifications } from './useGuidedSandboxModifications';

export function GuidedSandboxSection<S extends ShareDemoModalState>({
  organizationId,
  demoId,
}: {
  organizationId: string;
  demoId: string;
}) {
  const { guidanceTooltips } = useGuidedSandboxModifications({
    organizationId,
    demoId,
  });
  const { setFieldValue } = useFormikContext<S>();

  if (guidanceTooltips.length === 0) {
    return null;
  }

  return (
    <div className="p-2">
      <Field
        type="checkbox"
        name="showGuidanceTooltip"
      >
        {({ field: { checked, ...rest } }: FieldProps) => (
          <div className="flex items-center gap-2 just">
            <Checkbox
              {...rest}
              onChange={() => {
                setFieldValue('showGuidanceTooltip', !checked);
              }}
              checked={checked}
              name="showGuidanceTooltip"
              label={
                <TextBase
                  color="text-ds-natural-600"
                  label="Enable guided sandbox tooltips"
                />
              }
            />
          </div>
        )}
      </Field>
    </div>
  );
}
